module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row list-item clickable",
    on: {
      "click": _vm.viewContact
    }
  }, [_c('div', {
    staticClass: "table-col table-col-120 title"
  }, [_c('div', {
    staticClass: "name overflow-ellipsis"
  }, [(_vm.voipCall.contact.deleted_by_user_at) ? _c('span', {
    staticClass: "deleted-icon glyphicon glyphicon-remove"
  }) : _vm._e(), _vm._v(_vm._s(_vm.voipCall.contact.full_name))])]), _c('div', {
    staticClass: "table-col table-col-120"
  }, [_c('div', {
    staticClass: "name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.voipCall.business.name))])]), _c('div', {
    staticClass: "table-col date"
  }, [_vm._v(_vm._s(_vm.created_at))]), _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.bill_duration))])]), _c('div', {
    staticClass: "table-col type"
  }, [_vm._v(_vm._s(_vm.type))]), _c('div', {
    staticClass: "table-col table-col-30"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.voipCall.user,
      "options": {
        only_picture: true
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ed4dd03!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/voip_report/list_item.vue
// module id = 1144
// module chunks = 1